import { Component, Prop, Element, h, Method, Host, Event, EventEmitter } from '@stencil/core';
import { DropdownDirection, DropdownSize } from './types';

@Component({
  tag: 'zpr-dropdown-menu'
})
export class ZprDropdownMenu {
  private _dropdown: HTMLZprDropdownElement;

  @Element() el: HTMLElement;

  @Prop() parent: HTMLElement | string
  @Prop({ reflect: true }) direction: DropdownDirection
  @Prop({ reflect: true }) size: DropdownSize
  @Prop() matchToggleWidth: boolean = false
  @Prop() zIndex: string | undefined
  @Prop() fixOffset: boolean = false
  @Prop() minWidth: number;
  @Prop() minHeight: number;

  @Event() openChanged: EventEmitter<boolean>

  @Method()
  async open() {
    if (this.matchToggleWidth) {
      const rect = this.el.getBoundingClientRect()
      this._dropdown.style.width = `${rect.width}px`;
    }
    this._dropdown.open()
  }

  @Method()
  async close() {
    this._dropdown.close()
  }

  @Method()
  async toggle() {
    if (this.matchToggleWidth) {
      const rect = this.el.getBoundingClientRect()
      this._dropdown.style.width = `${rect.width}px`;
    }
    this._dropdown.toggle()
  }

  @Method()
  async isOpened() {
    return this._dropdown.isOpened()
  }

  render() {
    const offset = this.fixOffset ? { left: 24, top: 8 } : undefined
    const anchor: HTMLElement | undefined = this.parent ? (typeof this.parent === 'string' ? document.querySelector(this.parent) : this.parent) : undefined
    return <Host>
      <div onClick={this.toggle.bind(this)}><slot name="toggle" /></div>
      <zpr-dropdown direction={this.direction} size={this.size} ref={el => this._dropdown = el} zIndex={this.zIndex} offset={offset} minWidth={this.minWidth} minHeight={this.minHeight} anchor={anchor} onDropdown-open={ev => this.openChanged.emit(ev.detail)} class="dropdown-menu">
        <slot name="body" />
      </zpr-dropdown>
    </Host>
  }
}
